import styled from "styled-components";
import { media } from "../../theme/theme";
import { V3HeadlineH4 } from "../Typography";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";
import { CUSTOM_FONT_SET_SIZES } from "../../utils/getFontSetLabels";

export const PAHWrapper = styled.div<{ $showShadow: boolean, $nonSticky?: boolean }>`
    position: ${({ $nonSticky }) => $nonSticky ? "relative" : "sticky"};
    top: 0;
    background: ${({ $nonSticky, theme }) => $nonSticky ? undefined : theme.customization.backgroundColor};
    z-index: 2;
    box-shadow: ${({ $showShadow }) => $showShadow ? "0px 6px 12px rgba(0, 0, 0, 0.05);" : null};

    @media print {
        display: none;
    }
`;

export const PAHContainer = styled.div<{ $showAboutPagesNav : boolean }>`
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ $showAboutPagesNav }) => $showAboutPagesNav ? "23px 18px 11px" : "23px 18px" };
`;

export const PAHLeftSide = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;

    > div {
        &:first-child {
            width: 100%;
            margin-right: 12px;
        }
    }
`;

export const PAHRightSide = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            display: none;

            ${media.custom(900)} {
                display: block;
            }
        }
    }
`;
const UserThemableV3PublicHeaderAuthorName= styled(V3HeadlineH4)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3PublicHeaderAuthorName = styled(UserThemableV3PublicHeaderAuthorName) <AuthoryColorSchemeProps>`
    font-size: ${({ theme }) => {
        if (CUSTOM_FONT_SET_SIZES.includes(theme.customization.profileFontSet)) {
            return "18px";
        }
    }};
`;

export const V3PublicHeaderAuthorMeta = styled.div`
    display: flex;
    align-items: center;
    
    > div {
        &:first-child {
            margin-right: 16px;
        }
    }
`;